"use client";

import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { z } from "zod";

import { FormInput } from "@/components/custom";
import { Button } from "@/components/ui/button";
import { Form, FormDescription, FormField } from "@/components/ui/form";

import { asyncRegister } from "./actions";

const formSchema = z.object({
  email: z.string().email({ message: "Email хаяг буруу байна" }),
  username: z.string().min(2, {
    message: "Нууц нэр хамгийн багадаа 2 тэмдэгт байх ёстой",
  }),
  pin: z.string().length(4, "Пин код 4 оронтой байх ёстой"),
});

export default function RegisterForm() {
  const router = useRouter();
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
  });

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data, error } = await asyncRegister(values);
    if (data) {
      router.push("/auth");
      toast.success("Хэрэглэгч амжилттай бүртгэгдлээ", {
        position: "top-right",
      });
    } else {
      toast.error(error, { position: "top-right" });
    }
  }
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-5">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormInput placeholder="И-мэйл" field={field} />
          )}
        />
        <FormField
          control={form.control}
          name="username"
          render={({ field }) => (
            <FormInput
              nodeBeforeError={
                <FormDescription className="text-sm">
                  Та өөртөө хүссэн нэрээ өгөөрэй
                </FormDescription>
              }
              placeholder="Нууц нэр"
              field={field}
            />
          )}
        />
        <FormField
          control={form.control}
          name="pin"
          render={({ field }) => (
            <FormInput
              placeholder="4 оронтой пин код"
              type="number"
              field={field}
            />
          )}
        />
        <Button type="submit" className="w-full !mt-20 rounded-2xl">
          Нэвтрэх
        </Button>
      </form>
    </Form>
  );
}
